import React from 'react'
import Screen from '../Screen'
import Tracks from '../Tracks'
import { ScreenShareScreenProps, ScreenShareScreenState } from './types'
import MediaShareTitle from '../MediaShareTitle'
import { VideoType } from '@bt-react/components/Video'
import style from './ScreenShareScreen.module.scss'
import classnames from 'classnames'

/** Returns a Presenter Screen with the content type that was passed to it */
class ScreenShareScreen extends React.Component<ScreenShareScreenProps, ScreenShareScreenState> {

  state = {
    screenshareTrackSid: '',
    tracks: []
  }

  componentDidMount () {

    this.getTrackSid()

  }

  componentDidUpdate (prevProps) {

    if (prevProps.enabledVideoTracks !== this.props.enabledVideoTracks) this.getTrackSid()

  }

  setTrackSid = (screenshareTrackSid: string): void => this.setState({ screenshareTrackSid })
  unsetTrackSid = (): void => this.setState({ screenshareTrackSid: '' })
  getTrackSid = () => {

    return (this.props.enabledVideoTracks || []).length === 0
      ? this.unsetTrackSid()
      : this.setTrackSid(this.props.enabledVideoTracks[0].trackSid)

  }

  render () {

    if (typeof this.props.presenter === 'undefined') return <div />

    return <Screen>
      <div className={classnames(style['ScreenShareScreen__Divide'], {
          [style[`ScreenShareScreen__NoDivide`]]: this.props.isBridge
        })}
      >
        <div className={style['ScreenShareScreen__Tracks']}>
          <Tracks
            presenter={this.props.presenter}
            trackType={VideoType.VideoTrackType.SCREENSHARE}
            enabledVideoTracks={this.props.enabledVideoTracks}
          />
        </div>
        { !this.props.isBridge &&
          <MediaShareTitle
            text={`${this.props.presenter.name} is sharing their screen`}
            buttonText={'End screen share'}
            onButtonClick={() => this.props.onStop(this.props.isPresenterLayoutsActive, this.state.screenshareTrackSid)}
          />
        }
      </div>
    </Screen>

  }

}

export default ScreenShareScreen
